import styled from 'styled-components';

export const PageWrapper = styled.section`
  max-width: ${({ theme }) => theme.deprecated_.breakpoints.md};
  margin: 0 auto;
`;
